@if (boolean) {
  <div class="d-flex flex-column">
    <img id="loader" src="/assets/icons/loader.svg">
    @if (message) {
      <h1 class="align-self-center d-flex flex-row" id="loadingText">{{message}}<div class="p1 ml-1">.</div><div class="p2 ml-1">.</div><div class="p3 ml-1">.</div></h1>
    }
  </div>
} @else {
  <div class="error d-flex flex-column justify-content-center align-items-center">
    <h2 class="text-center">{{search}}</h2>
    <div class="d-flex flex-row">
      <h3 class="text-center">{{order}}</h3>
      @for (f of lfilters; track f) {
        <div>
          @if (f=='No filter active') {
            <h5>{{f}}</h5>
          }
          @if (f!='No filter active') {
            <h5 class="filtersaffiche">{{f}}</h5>
          }
        </div>
      }
    </div>
    <img id="notfound" src="assets/images/Components/not-found.svg">
  </div>
}
